var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-box-container",class:_vm.hide ? '' : 'hide'},[_c('div',{staticClass:"h-100"},[(_vm.showList)?_vm._t("list"):_vm._e(),(!_vm.showList)?_vm._t("chat"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }